module.exports = __webpack_public_path__ + "static/media/erply-logo-white.32bfa687.svg";